export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD';